document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-sub-pricing]').forEach(function (root) {
    // The calculator panel can be relocated into the modal (and onto <body>),
    // so query the steppers relative to the panel, not root — root no longer
    // contains them once the modal is open.
    const calc = root.querySelector('[data-sub-panel]') || root;

    const valueInputs = {};
    calc.querySelectorAll('.sub-pricing-step-value').forEach(function (input) {
      valueInputs[input.dataset.value] = input;
    });

    // One key per purchasable add-on, as rendered from the metafield — logos /
    // products / codes today, plus anything else the Launch app adds.
    const KEYS = Object.keys(valueInputs);

    // Each card carries its own base price and, per key, the included baseline,
    // the add-on unit price and the max EXTRA units it may buy — all per plan,
    // straight from the metafield.
    const plans = [];
    root.querySelectorAll('[data-plan]').forEach(function (el) {
      let cfg = {};
      const cfgEl = el.querySelector('[data-plan-config]');
      if (cfgEl) {
        try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { cfg = {}; }
      }
      plans.push({
        el: el,
        base: parseFloat(cfg.base) || 0,
        keys: cfg.keys || {},
      });
    });

    function planKey(plan, key) {
      return plan.keys[key] || { included: 0, unit: 0, max: 0 };
    }

    // Requested EXTRA units from the steppers.
    const requested = {};
    KEYS.forEach(function (key) { requested[key] = 0; });

    // Per-key ceiling for the shared stepper: the biggest headroom any plan
    // grants for that add-on. That lets the more generous plan reach its full
    // limit while smaller plans simply clamp their own total/charge below
    // (computed per plan in render()).
    const stepperMax = {};
    KEYS.forEach(function (key) {
      stepperMax[key] = plans.reduce(function (max, plan) {
        return Math.max(max, parseInt(planKey(plan, key).max, 10) || 0);
      }, 0);
    });

    function formatPrice(symbol, amount) {
      // Keep whole numbers clean, show 2 decimals only when needed.
      const rounded = Math.round(amount * 100) / 100;
      const str = Number.isInteger(rounded) ? String(rounded) : rounded.toFixed(2);
      return symbol + str;
    }

    const reduceMotion = window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    // Tween a price element from its current value up/down to `target`, so the
    // number counts one step at a time (e.g. 231 -> 250). Stores state on the
    // element so rapid clicks retarget the same animation instead of stacking.
    function animatePrice(el, symbol, target) {
      const current = typeof el._priceValue === 'number' ? el._priceValue : target;
      el._priceValue = target;

      if (reduceMotion || current === target) {
        if (el._priceRAF) cancelAnimationFrame(el._priceRAF);
        el._priceRAF = null;
        el.textContent = formatPrice(symbol, target);
        el._priceShown = target;
        return;
      }

      const from = typeof el._priceShown === 'number' ? el._priceShown : current;
      const distance = Math.abs(target - from);
      // Scale duration with the jump, but keep it snappy and bounded.
      const duration = Math.min(600, 180 + distance * 6);
      let startTime = null;

      if (el._priceRAF) cancelAnimationFrame(el._priceRAF);

      function step(now) {
        if (startTime === null) startTime = now;
        const t = Math.min(1, (now - startTime) / duration);
        // easeOutCubic for a natural settle.
        const eased = 1 - Math.pow(1 - t, 3);
        const value = from + (target - from) * eased;
        const shown = Math.round(value);
        el.textContent = formatPrice(symbol, shown);
        el._priceShown = shown;
        if (t < 1) {
          el._priceRAF = requestAnimationFrame(step);
        } else {
          el.textContent = formatPrice(symbol, target);
          el._priceShown = target;
          el._priceRAF = null;
        }
      }
      el._priceRAF = requestAnimationFrame(step);
    }

    function render(skipKey) {
      // Clamp every requested value to its shared-stepper ceiling first, so
      // typing a huge number in the field snaps back to the allowed maximum.
      KEYS.forEach(function (key) {
        requested[key] = Math.min(requested[key], stepperMax[key]);
      });

      // Update stepper displays. Skip the field currently being typed in so we
      // don't clobber the user's caret position mid-edit.
      KEYS.forEach(function (key) {
        if (key !== skipKey && valueInputs[key]) valueInputs[key].value = requested[key];
      });

      // Recalculate each plan from its own config (base price, and per key the
      // included baseline, add-on unit price and max extra units).
      plans.forEach(function (plan) {
        let extra = 0;

        KEYS.forEach(function (key) {
          const k = planKey(plan, key);
          const inc = parseInt(k.included, 10) || 0;
          const max = parseInt(k.max, 10) || 0;

          // Grant (and charge for) only the extras this plan actually allows,
          // so a smaller plan isn't billed for units beyond its own limit.
          const extras = Math.min(requested[key], max);
          extra += extras * (parseFloat(k.unit) || 0);

          const el = plan.el.querySelector('[data-total="' + key + '"]');
          if (el) el.textContent = inc + extras;
        });

        const amountEl = plan.el.querySelector('[data-price-amount]');
        if (amountEl) {
          // Capture the currency symbol once from the server-rendered text;
          // after the first animation the text is a plain number.
          if (!amountEl._priceSymbol) {
            amountEl._priceSymbol = (amountEl.textContent.match(/^\D+/) || ['$'])[0];
          }
          animatePrice(amountEl, amountEl._priceSymbol, plan.base + extra);
        }
      });

      // Disable minus buttons at zero and plus buttons at the shared ceiling.
      calc.querySelectorAll('.sub-pricing-step--minus').forEach(function (btn) {
        btn.disabled = requested[btn.dataset.step] <= 0;
      });
      calc.querySelectorAll('.sub-pricing-step--plus').forEach(function (btn) {
        const key = btn.dataset.step;
        btn.disabled = requested[key] >= stepperMax[key];
      });
    }

    calc.querySelectorAll('.sub-pricing-step').forEach(function (btn) {
      btn.addEventListener('click', function () {
        const key = btn.dataset.step;
        const dir = parseInt(btn.dataset.dir, 10);
        requested[key] = Math.min(stepperMax[key], Math.max(0, (requested[key] || 0) + dir));
        render();
      });
    });

    // Allow typing a quantity directly into the field.
    Object.keys(valueInputs).forEach(function (key) {
      const input = valueInputs[key];
      input.addEventListener('focus', function () {
        input.select();
      });
      input.addEventListener('input', function () {
        // Keep only digits, then update the requested state and recalc prices
        // without rewriting the field the user is actively editing.
        const digits = input.value.replace(/\D/g, '');
        input.value = digits;
        requested[key] = parseInt(digits, 10) || 0;
        render(key);
      });
      input.addEventListener('blur', function () {
        // Normalize an empty/partial entry back to a clean number.
        requested[key] = Math.max(0, parseInt(input.value, 10) || 0);
        render();
      });
    });

    const resetBtn = calc.querySelector('[data-sub-reset]');
    if (resetBtn) {
      resetBtn.addEventListener('click', function () {
        KEYS.forEach(function (key) { requested[key] = 0; });
        render();
      });
    }

    // ---- Customize calculator modal (<=1023px only) ----
    // Above 1023px the calculator panel sits inline in the card (original
    // layout). At <=1023px the panel is hidden inline and instead moved into a
    // modal opened from each plan's "Customize" button. There is only one panel
    // DOM node, so the calculator state is always shared. render() already
    // writes prices straight to the plan cards, so Apply just closes the modal
    // and the updated prices are revealed.
    const modal = root.querySelector('[data-sub-modal]');
    const panel = root.querySelector('[data-sub-panel]');
    const mount = modal && modal.querySelector('[data-sub-modal-mount]');
    if (modal && panel && mount) {
      const dialog = modal.querySelector('.sub-pricing-modal-dialog');
      const mq = window.matchMedia('(max-width: 1023px)');
      let lastFocused = null;

      function openModal(trigger) {
        if (!mq.matches) return; // Inline panel is visible on desktop.
        lastFocused = trigger || document.activeElement;
        // Move the modal to <body> so its full-screen overlay can't be clipped
        // or out-stacked by any ancestor (cards, sections, headers).
        if (modal.parentNode !== document.body) document.body.appendChild(modal);
        // Relocate the live panel into the modal.
        mount.appendChild(panel);
        modal.hidden = false;
        void modal.offsetWidth; // reflow so the open transition runs
        modal.classList.add('is-open');
        document.documentElement.classList.add('sub-pricing-modal-lock');
        if (dialog) dialog.focus();
        document.addEventListener('keydown', onKeydown);
      }

      function restorePanel() {
        // Put the panel back as the card's first child (before the plans grid).
        root.insertBefore(panel, root.firstChild);
      }

      function closeModal() {
        modal.classList.remove('is-open');
        document.documentElement.classList.remove('sub-pricing-modal-lock');
        document.removeEventListener('keydown', onKeydown);
        const finish = function () {
          modal.hidden = true;
          restorePanel();
          modal.removeEventListener('transitionend', finish);
        };
        modal.addEventListener('transitionend', finish);
        // Fallback if transitionend doesn't fire (reduced motion, etc.).
        setTimeout(function () {
          if (!modal.classList.contains('is-open') && !modal.hidden) {
            modal.hidden = true;
            restorePanel();
          }
        }, 350);
        if (lastFocused && typeof lastFocused.focus === 'function') lastFocused.focus();
      }

      function onKeydown(e) {
        if (e.key === 'Escape') { closeModal(); return; }
        if (e.key !== 'Tab' || !dialog) return;
        const focusables = dialog.querySelectorAll(
          'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
        );
        if (!focusables.length) return;
        const first = focusables[0];
        const last = focusables[focusables.length - 1];
        if (e.shiftKey && document.activeElement === first) {
          e.preventDefault(); last.focus();
        } else if (!e.shiftKey && document.activeElement === last) {
          e.preventDefault(); first.focus();
        }
      }

      // If the viewport grows past 1023px while the modal is open, snap it
      // closed and return the panel inline so the desktop layout is correct.
      mq.addEventListener('change', function (e) {
        if (!e.matches && !modal.hidden) {
          modal.classList.remove('is-open');
          modal.hidden = true;
          document.documentElement.classList.remove('sub-pricing-modal-lock');
          document.removeEventListener('keydown', onKeydown);
          restorePanel();
        }
      });

      root.querySelectorAll('[data-sub-customize-open]').forEach(function (btn) {
        btn.addEventListener('click', function () { openModal(btn); });
      });
      modal.querySelectorAll('[data-sub-modal-close]').forEach(function (el) {
        el.addEventListener('click', closeModal);
      });
      // The Apply button lives inside the panel, which is moved in/out of the
      // modal — query from root (where it always exists), not from the modal.
      const applyBtn = root.querySelector('[data-sub-modal-apply]');
      if (applyBtn) applyBtn.addEventListener('click', closeModal);
    }

    // Show / collapse features toggle. The panel animates via the CSS grid
    // 0fr<->1fr slide; JS just toggles aria-expanded + the .expanded class.
    const featToggle = root.querySelector('[data-features-toggle]');
    if (featToggle) {
      const panel = document.getElementById(featToggle.getAttribute('aria-controls'));
      featToggle.addEventListener('click', function () {
        const isOpen = featToggle.getAttribute('aria-expanded') === 'true';
        featToggle.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
        if (panel) panel.classList.toggle('expanded', !isOpen);
      });
    }

    render();
  });
});

// ---- Hero overlay parallax ----
// Subtly translates the overlay image as the hero scrolls past. Disabled when
// the visitor prefers reduced motion.
document.addEventListener('DOMContentLoaded', function () {
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var layers = Array.prototype.slice.call(document.querySelectorAll('[data-sub-hero-parallax]'));
  if (reduceMotion || !layers.length) return;

  var ticking = false;

  function update() {
    ticking = false;
    var scrollY = window.pageYOffset;
    layers.forEach(function (el) {
      var speed = parseFloat(el.dataset.parallaxSpeed);
      if (isNaN(speed) || speed === 0) return;
      // Move the overlay down as the page scrolls down, for a gentle drift.
      el.style.transform = 'translate3d(0, ' + (scrollY * speed) + 'px, 0)';
    });
  }

  function onScroll() {
    if (!ticking) {
      window.requestAnimationFrame(update);
      ticking = true;
    }
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  update();
});
